import React from 'react';
import Footer from "./Footer";
import Navbar from "./Navbar";
import ProfileUsers from "./ProfileUsers";

function History() {
    return (
        <div>
            <Navbar />
            <ProfileUsers />
            <Footer />
        </div>
    )
}

export default History;